import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const services = [
    {
      icon: 'ri-code-s-slash-line',
      title: 'Programmation informatique',
      description: 'Création de logiciels et outils informatiques adaptés aux besoins spécifiques de votre entreprise.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Développement sur mesure',
      description: 'Conception d\'applications et de solutions numériques personnalisées pour optimiser vos processus.',
    },
    {
      icon: 'ri-server-line',
      title: 'Installation de serveurs',
      description: 'Configuration et gestion d\'infrastructures informatiques sécurisées et performantes.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Support informatique',
      description: 'Maintenance, assistance technique et dépannage pour assurer la continuité de vos activités.',
    },
  ];

  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Solutions sécurisées',
      description: 'Protection optimale de vos données et infrastructures informatiques',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Accompagnement personnalisé',
      description: 'Un service adapté à vos besoins spécifiques et à votre budget',
    },
    {
      icon: 'ri-time-line',
      title: 'Réactivité garantie',
      description: 'Intervention rapide pour résoudre vos problèmes techniques',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-32 pb-20 px-6 lg:px-8 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-gray-50"></div>
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-10 text-9xl font-mono text-gray-400">&lt;/&gt;</div>
          <div className="absolute bottom-20 right-10 text-9xl font-mono text-gray-400">{ }</div>
        </div>
        
        <div className="relative max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <div className="inline-flex items-center px-4 py-2 rounded-full border border-blue-600 bg-white/80 backdrop-blur-sm mb-6">
              <span className="text-sm font-medium text-blue-600">Solutions IT Professionnelles</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Solutions informatiques et développement logiciel
            </h1>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-2xl">
              Rafal Szelenc IT Services accompagne les entreprises et les particuliers dans la mise en place de solutions informatiques fiables et efficaces. L'activité comprend le développement de logiciels personnalisés, la gestion d'infrastructures informatiques et le support technique.
            </p>
            
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Contactez-nous pour votre projet
              <i className="ri-arrow-right-line ml-2 text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 rounded-full border border-blue-600 bg-blue-50 mb-4">
              <span className="text-sm font-medium text-blue-600">Nos Services</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Expertise technique complète pour vos projets informatiques
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Des solutions adaptées à chaque besoin, de la conception au support
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-600 hover:bg-blue-600 transition-all duration-300 shadow-sm hover:shadow-xl cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-gray-100 group-hover:bg-white/20 rounded-lg mb-6 transition-colors">
                  <i className={`${service.icon} text-3xl text-blue-600 group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-white mb-3 transition-colors">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 group-hover:text-white/90 leading-relaxed transition-colors">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 rounded-full border border-gray-300 bg-white mb-6">
                <span className="text-sm font-medium text-gray-700">À propos</span>
              </div>
              <img
                src="https://public.readdy.ai/ai/img_res/66781f8ffefdfdcb3858faede24150ec.jpg"
                alt="Espace de travail professionnel"
                className="w-full h-auto rounded-2xl shadow-lg object-cover"
              />
            </div>

            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Ingénieur informatique basé à Toulouse
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Rafal Szelenc IT Services est une activité indépendante spécialisée dans la programmation informatique et les services IT, dirigée par Rafal Jozef Szelenc, ingénieur informatique diplômé de l'Université Jagellonne de Cracovie.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Grâce à ses compétences techniques approfondies, Rafal accompagne les entreprises et particuliers dans la création de solutions informatiques performantes, fiables et sécurisées.
              </p>
              <Link
                to="/a-propos"
                className="inline-flex items-center px-8 py-3 bg-gray-900 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <div className="w-2 h-2 bg-blue-600 rounded-full mr-2"></div>
              <span className="text-sm font-medium text-gray-600">Pourquoi nous choisir</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Solutions fiables et sécurisées
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Accompagnement personnalisé pour chaque projet
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-600 transition-all duration-300 shadow-sm hover:shadow-lg"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-6">
                  <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
                <div className="flex items-center mt-4 text-sm text-gray-700">
                  <i className="ri-check-line text-blue-600 mr-2"></i>
                  <span>Service professionnel garanti</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="bg-blue-600 px-8 lg:px-16 py-20 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 left-10 text-6xl font-mono text-white">{'<code>'}</div>
              <div className="absolute bottom-10 right-10 text-6xl font-mono text-white">{'</code>'}</div>
            </div>
            <div className="relative">
              <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
                Discutons de votre projet
              </h2>
            </div>
          </div>

          <div className="bg-white px-8 lg:px-16 py-20 flex flex-col justify-center">
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 text-center">
              Contactez-nous dès aujourd'hui
            </h3>
            <p className="text-lg text-gray-600 mb-8 text-center leading-relaxed">
              Nous sommes à votre écoute pour comprendre vos besoins et vous proposer des solutions adaptées à votre activité.
            </p>
            <div className="text-center">
              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-4 bg-gray-900 text-white font-semibold rounded-full hover:bg-gray-800 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Envoyer un message
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}